
const ordered = (unordered) => {

  if (!unordered) {
    return unordered;
  }

  if (typeof (unordered) == 'object') {
    // object
    if (unordered.length === undefined) {
      return Object.keys(unordered).sort().reduce(
        (obj, key) => {
          obj[key] = ordered(unordered[key]);
          return obj;
        },
        {}
      )
    }
    else {
      // list
      return unordered.sort();
    }
  }
  // Primitive
  else return unordered;
};

export default ordered;